export enum VersioningContentType {
  blog = "blog",
  product = "product",
}
